import {
  NEW_CONTRACTS,
  NEW_SINGLE_CONTRACT,
  NEW_SINGLE_CONTRACT_PORTAL,
  NEW_CONTRACTS_FILTERS,
  NEW_LOADING_TABLE,
  NEW_SEARCHING
} from '../actions/contractActions';

import {
  RESET_ACCOUNT,
  LOG_OUT

} from '../actions/accountActions';

const initialState = {
  page : null,
  contract: null,
  portalContract: null,
  activeFilters: [{
    label: 'Fecha contratos',
    filterKey: 'started_at',
    type: 'date',
    filterCondition: 'btw',
    value: '',
    period: 'Todo'
  },{
    label: 'Buscar',
    filterKey: 'general',
    type: 'search',
    value: '',
    personalized: true
  },{
    label: 'Página',
    filterKey: 'page',
    type: 'page',
    value: 1,
    personalized: true
  },{
    label: 'Estado',
    filterKey: 'status',
    type:'options',
    options: [
      { label: 'Activo', value: 'active' },
      { label: 'Cancelado', value: 'inactive' }
    ],
    value: 'active,inactive',
    personalized: true
  }],
  updateTable: true,
  loadingTable: true
} // END initialState


export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch (type) {
    case NEW_CONTRACTS:
      newState = { page: payload };
      return { ...state, ...newState };

    case NEW_SINGLE_CONTRACT:
      newState = { contract: payload };
      return { ...state, ...newState };

    case NEW_SINGLE_CONTRACT_PORTAL:
      newState = { portalContract: payload };
      return { ...state, ...newState };

    case NEW_CONTRACTS_FILTERS:
      newState = { activeFilters: payload.filters , updateTable: payload.updateTable, searching: payload.searching };
      return { ...state, ...newState };

    case NEW_LOADING_TABLE:
      newState = { loadingTable: payload }
      return { ...state, ...newState };

    case NEW_SEARCHING:
      newState = { searching: payload };
      return { ...state, ...newState };

    case RESET_ACCOUNT:
    case LOG_OUT:
      newState = { initialState }
      return { ...state, ...initialState };

    default:
      return state;

  } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/contractReducer.js